import { ReactNativeMessageTypes } from 'Types/common';

interface ReactNativeMessage {
  type: ReactNativeMessageTypes;
  data: Record<string, unknown>;
}

export const isNative = (): boolean => {
  return window.ReactNativeWebView !== undefined;
};

const assertNative = (): void => {
  if (!isNative()) {
    throw new Error('Not in a React Native environment');
  }
};

const sendNativeMessage = (message: ReactNativeMessage): void => {
  assertNative();
  window.ReactNativeWebView.postMessage(JSON.stringify(message));
};

export const identifyNative = ({ userId, email }: { userId: string; email: string }): void => {
  sendNativeMessage({ type: ReactNativeMessageTypes.analyticsIdentify, data: { userId, email } });
};

export const openNativeLink = (link: string): void => {
  sendNativeMessage({ type: ReactNativeMessageTypes.openLink, data: { link } });
};

export const openLinkExternal = (url: string): void => {
  sendNativeMessage({ type: ReactNativeMessageTypes.openLinkExternal, data: { url } });
};

export const openModalForReview = (): void => {
  sendNativeMessage({ type: ReactNativeMessageTypes.openRating, data: {} });
};

export const openPdfFile = (filename: string, base64: string): void => {
  sendNativeMessage({ type: ReactNativeMessageTypes.writeToDisk, data: { filename, base64 } });
};

export const resetNative = (): void => {
  sendNativeMessage({ type: ReactNativeMessageTypes.analyticsReset, data: {} });
};

export const triggerModalForReview = (): void => {
  if (isNative()) {
    openModalForReview();
  }
};
